import React, { useState, useEffect } from "react";
import ReactDOMServer from "react-dom/server";

import { Marker, TileLayer } from "react-leaflet";
import Leaflet from "leaflet";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";
import { ISearchMapProps } from "./SearchMapProps";
import { StyledMap, HotelEmpty } from "./SearchMapHelpers";

import HotelMapMarker from "../../HotelMapMarker/HotelMapMarker";
import HotelCard from "../../HotelCard/HotelCard";
import { isBrowser } from "../../../../utils/helpers";

const SearchMap: React.FC<ISearchMapProps> = ({
  search,
  hotels,
  isLoading,
  onClickHotelImage,
  onRateLoad,
  isPromoValid,
}) => {
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [center, setCenter] = useState([search.latitude, search.longitude]);

  useEffect(() => {
    setSelectedHotel(null);
    setCenter([search.latitude, search.longitude]);
  }, [search.latitude, search.longitude]);
  useEffect(() => {
    setSelectedHotel(null);
  }, [isLoading]);
  const handleSetHotel = (event: any) => {
    setSelectedHotel(null);
    const hotel = hotels.filter(
      (data: { crsHotelCode: any }) =>
        data.crsHotelCode === event.target.options.data.crsHotelCode
    );
    setSelectedHotel({
      hotel: hotel[0],
    });
  };
  if (isLoading) {
    return (
      <Col>
        <Spinner animation="border" />
      </Col>
    );
  } else if (isBrowser && hotels.length) {
    const bounds = [center];

    const CenterPin = new Leaflet.divIcon({
      html: ReactDOMServer.renderToString(
        <svg>
          <use xlinkHref="/svg/icon-pin-red.svg#RedPin"> </use>
        </svg>
      ),
      iconSize: [36, 36],
      className: "center-map-pin",
    });
    if (!isLoading) {
      hotels.map((hotel) => {
        bounds.push([hotel.coordinates.latitude, hotel.coordinates.longitude]);
      });
    }
    const options = {
      //   zoom: 4,
      center: center,
      bounds: bounds,
      scrollWheelZoom: false,
    };
    return (
      <React.Fragment>
        <Col xs={12} lg={4}>
          {selectedHotel !== null ? (
            <HotelCard
              {...selectedHotel}
              stacked={true}
              display="map"
              isPromoValid={isPromoValid}
              onClickHotelImage={onClickHotelImage}
            />
          ) : (
            <HotelEmpty>
              <h2 className="w-100 text-center">Select a Hotel</h2>
            </HotelEmpty>
          )}
        </Col>
        <Col xs={12} lg={8}>
          <StyledMap options={options} aria-hidden="true">
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={center} icon={CenterPin} />
            {hotels.map((hotel, index) => {
              if (hotel.coordinates !== null) {
                const isSelected =
                  selectedHotel &&
                  selectedHotel.hotel?.crsHotelCode == hotel?.crsHotelCode;
                return (
                  <HotelMapMarker
                    key={index}
                    onMarkerClick={handleSetHotel}
                    onRateLoad={onRateLoad}
                    priceFilter={search.priceFilter}
                    hotel={hotel}
                    className={isSelected ? "active" : ""}
                  />
                );
              }
            })}
          </StyledMap>
        </Col>
      </React.Fragment>
    );
  }
  return null;
};
export default SearchMap;
